import { useNavigate } from 'react-router-dom';
import ButtonComponent from "../../components/ButtonComponent";
 
type BigButtonType = {
  path: string | undefined;
  label: string;
  onClickFunction?: () => Promise<void>;
  alignItems?: string;  // Adiciona a propriedade opcional para alinhamento, por defeito metemos center
  height?: string;
  minHeight?: string;
  minWidth?: string;
  fontSize?: string;
  padding?: string;
  lineHeight?: string;
}

export function BigButton({ path, label, onClickFunction, alignItems = 'center', height = '300px', minHeight, minWidth, fontSize = '20px', padding, lineHeight = '1' }: BigButtonType) {
  const navigate = useNavigate();
 
  const handleClick = () => {
    if (path) {
      navigate(path);
    }
    if (onClickFunction) {
      onClickFunction();
    }
  };
 
  return (
<ButtonComponent
      text={label}
      onClick={handleClick}
      style={{
        width: "250px",
        height: height,
        minHeight: minHeight,
        minWidth: minWidth,
        padding: padding,
        fontSize: fontSize,
        whiteSpace: "pre-wrap",
        overflowY: "auto",
        display: "flex",
        alignItems: alignItems,
        textAlign: "center",
        boxSizing: "border-box",
        lineHeight: lineHeight
      }}
    />
  )
}
